import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { msalConfig } from "../authConfig.js";
export class BaseApiService {

    msalInstance = null;
    requiresAuth = true;

    constructor(msalInstance, requiresAuth = true) {
        this.msalInstance = msalInstance;
        this.requiresAuth = requiresAuth;
    }

    async get(url) {
        return this.request('GET', url);
    }

    async post(url, data) {
        return await this.request('POST', url, data);
    }

    async put(url, data) {
        return await this.request('PUT', url, data);
    }

    async request(method, url, data) {
        const requestParams = await this.getRequestParams(method, data);
        const response = await fetch(url, requestParams);

        return response.json();
    }

    async getRequestParams(method, data) {
        const headers = {
            'Accepts': 'application/json'
        };

        if (this.requiresAuth) {
            const accesssToken = await this.getAccessToken();
            headers['Authorization'] = `Bearer ${accesssToken}`;
        }

        if (data) {
            headers['Content-Type'] = 'application/json';
        }

        return {
            method: method,
            headers: headers,
            body: data ? JSON.stringify(data) : null
        };
    }

    async getAccessToken() {
        const account = this.msalInstance.getActiveAccount();
        const authRequest = { scopes: msalConfig.auth.scope, account };

        if (!account) {
            throw Error("No active account! Verify a user has been signed-in and setActiveAccount has been called.");
        }

        try {
            const response = await this.msalInstance.acquireTokenSilent(authRequest);

            return response.accessToken;
        } catch (error) {
            if (error instanceof InteractionRequiredAuthError) {
                return this.msalInstance.acquireTokenRedirect(authRequest);
            }
            else {
                throw error;
            }
        }
    }
}